"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOtpChannelTypes = void 0;
/**
 * Типы каналов
 *
 * Не путать с типами контрактов 'EOtpHandlerContracts' !
 * При добавлении новых типов не забыть добавить их в `OtpChannelTypeToOtpHandlerContractsMap` и в 'OtpChannelCodeTypeMap' !
 */
var EOtpChannelTypes;
(function (EOtpChannelTypes) {
    EOtpChannelTypes["sms"] = "sms";
    EOtpChannelTypes["sim_push"] = "sim_push";
    EOtpChannelTypes["viber"] = "viber";
    EOtpChannelTypes["voice"] = "voice";
    EOtpChannelTypes["vk"] = "vk";
    EOtpChannelTypes["whatsapp"] = "whatsapp";
    EOtpChannelTypes["flashcall"] = "flashcall";
})(EOtpChannelTypes || (exports.EOtpChannelTypes = EOtpChannelTypes = {}));
//# sourceMappingURL=OtpChannelTypes.enum.js.map